'use client'
import React from 'react'
import ContactUs from '@/app/[lng]/components/(MiniWebsite)/ContactUs/ContactUs'

const page = ({ params }: { params: { id: string } }) => {
  return <ContactUs id={params.id} />
}

export default page
